import React from 'react'
import { withIcon } from '../../withIcon'

function VoiceModeIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M10.8748 19.125C10.8748 19.6082 10.4831 20 9.99984 20C9.51659 20 9.12484 19.6082 9.12484 19.125L9.12488 4.875C9.12488 4.39175 9.51664 4 9.99989 4C10.4831 4 10.8749 4.39175 10.8749 4.875L10.8748 19.125Z" fill={color}/>
      <path d="M6.87484 13.7914C6.87484 14.2746 6.48309 14.6664 5.99984 14.6664C5.51659 14.6664 5.12484 14.2746 5.12484 13.7914L5.12484 10.2084C5.12484 9.72511 5.51659 9.33336 5.99984 9.33336C6.48309 9.33336 6.87484 9.72511 6.87484 10.2084L6.87484 13.7914Z" fill={color}/>
      <path d="M14.8749 17.3471C14.8749 17.8303 14.4831 18.2221 13.9999 18.2221C13.5166 18.2221 13.1249 17.8303 13.1249 17.3471L13.125 6.65274C13.125 6.16949 13.5168 5.77774 14 5.77774C14.4833 5.77774 14.875 6.16949 14.875 6.65274L14.8749 17.3471Z" fill={color}/>
      <path d="M18.875 13.7914C18.875 14.2746 18.4833 14.6664 18 14.6664C17.5168 14.6664 17.125 14.2746 17.125 13.7914L17.1251 10.2084C17.1252 9.72512 17.5169 9.33337 18.0002 9.33337C18.4834 9.33337 18.8752 9.72512 18.8751 10.2084L18.875 13.7914Z" fill={color}/>
    </svg>
  )
}

export default withIcon(VoiceModeIcon)
